import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconSearch } from "@tabler/icons-react";
import { CloseIcon } from "@mantine/core";

const CustomSearch = ({ search, onSearch, textInputClassName }) => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState(search);
  const handleSearch = () => {
    onSearch(searchQuery);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  const handleClear = (e) => {
    e.preventDefault();
    setSearchQuery("");
    onSearch("");
  };
  return (
    <div className="flex justify-between items-center ml-auto xs:w-full">
      <div className="relative flex items-center p-1 xs:w-full">
        <input
          type="text"
          placeholder={t("placeholders.search")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={handleKeyPress}
          className={`border border-gray-300 dark:bg-slate-600
          md:text-sm text-base leading-6 ${textInputClassName}
                     rounded-md py-1 px-3 pr-10 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 focus:text-orange-500::placeholder
                     dark:focus:ring-orange-800 dark:focus:border-orange-800 dark:focus:text-orange-800::placeholder dark:focus-white dark:text-white`}
        />
        <div className="flex absolute inset-y-0 right-0 items-center pr-3">
          {searchQuery ? (
            <CloseIcon onClick={handleClear} size={18} color="#1E44FF" />
          ) : (
            <IconSearch size={18} color="gray" />
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomSearch;
